export default {
    '1b-diagram3': {
        'diagram-task': 'Arrange the points to fit the pyramid structure, then press the Submit button',
        'fixed-answer': 'Eighteenth century people did not see the cosmos as an immense mystery',
        'element_3_1': 'Only a few thousand years old<br><br>(young)',
        'element_3_2': 'Stretching only a few million miles above<br><br>(small)',
        'element_3_3': 'Stars physically close to the earth<br><br>(close by)',
        'element_3_4': 'Influencing everyday life<br><br>(influential)'
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/1/1b/diagram3/i18n/en.js